<!-- 要求：
  PC、移动适应 -->

<!-- 表单：
  姓名、昵称、密码、确认密码、部门选择、提交
    弹窗：
      信息预览确认
 -->


<!-- 逻辑：
  token：判断是否失效
  部门：可多选 -->


<!-- 提交后，弹窗预览，确认事件进行提交 -->

<template style="background-color: white;">
  <el-row>
    <el-col :span='24'>
      <el-form ref="form" :model="form" label-width="80px"  style="background-color: white; padding: 1.25rem">
        <h3>用户注册</h3>
        <el-form-item label="姓名">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.user_name" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" placeholder="请输入密码"  show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="form.passdowds" placeholder="请输入密码"  show-password></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <div style="display: flex;">
            <div class="ercitankuang_left">
              <!-- <el-input
              style="margin-top: 1rem; margin-left: 1rem; margin-bottom: 0.3rem; width: 90%;"
                placeholder="部门名称"
                v-model="info.filterText">
              </el-input> -->
              <el-tree   @node-click="section_fid"
                 :data="info.section_list"
                  ref="tree"
                  node-key="id"
                 :filter-node-method="filterNode"
                 :props="defaultProps"
                 >
             </el-tree>
            </div>
          </div>
             <div class="ercitankuang_content">
              <span>您选择的部门是：</span>
            </div>
              <div class="ercitankuang_right">
                <span style="margin-right: 1.25rem;" v-for="(item,i) in form.user_section ">{{item.name}}
                <i class="el-icon-close" @click="del(i)"></i>
                </span>
               <!-- <div v-html="section_choiced.html" @click="del_section_edit_fid_click($event)"></div> -->
              </div>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
          <!-- <el-button>取消</el-button> -->
        </el-form-item>
      </el-form>
    </el-col>
    <el-dialog title="信息确认 ":visible.sync="confirm.show" >
      <el-row>
        <span style="margin-top: 1.875rem;">姓名：</span><span>{{form.name}}</span>
      </el-row>
      <el-row style="margin-top: 1.875rem;">
        <span>昵称：</span><span>{{form.user_name}}</span>
      </el-row>
      <el-row style="margin-top: 1.875rem;">
        <span>密码：</span><span>{{form.password}}</span>
      </el-row>
      <el-row style="margin-top: 1.875rem;">
        <span>确认密码：</span><span>{{form.passdowds}}</span>
      </el-row>
      <el-row style="margin-top: 1.875rem;">
        <span>所属部门：</span><span v-for="item in form.user_section" style="margin-right: 1.25rem;">{{item.name}}</span>
      </el-row>
       <div slot="footer" class="dialog-footer">
         <el-button @click="confirm.show=false" size="mini">取 消</el-button>
         <el-button type="primary" @click="updata()" size="mini">确 定</el-button>
       </div>
    </el-dialog>
  </el-row>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          token:this.$route.query.token,
          name: '',
          user_name:'',
          password:'',
          passdowds:'',
          user_section:[]
        },
        info:{
          filterText:'',
          section_list:[]

        },
        section_choiced:{
          type:'',
          html:''
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        confirm:{
          show:false
        }
      }
    },
    mounted: function() {
      this.get_section()
    },
    methods: {
      updata(){
        let _this=this
        _this.axios.post("/v2/share/save_companyee",{info:_this.form}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.confirm.show=false
              _this.$message.success(res.data.msg)
              _this.form={
                token:this.$route.query.token,
                name: '',
                user_name:'',
                password:'',
                passdowds:'',
                user_section:[]
              }
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      get_section(){
        let _this = this;
          _this.axios
        .get("/v2/share/get_section_list",{
          params:{'token':_this.form.token},
          }
        )
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.section_list=res.data.data;
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      onSubmit() {
        let _this=this
        _this.confirm.show=true
      },
      section_fid(data){
        let _this=this
        _this.form.user_section.push(data)
      },
      del(i){
        this.form.user_section.splice(i,1)
      },
      filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
          },
    }
  }
</script>

<style>
  .ercitankuang_left{
   border:1px solid 	#9D9D9D;
   height: 200px;
   flex: 1;
   overflow:scroll;
  }
  .ercitankuang_right{
    border:1px solid 	#9D9D9D;
    height: 200px;
    flex: 1;
    overflow:scroll;
  }
</style>



// WEBPACK FOOTER //
// src/view/share/companyee_insert.vue